import _ from 'lodash';

import definitions from './definitions';
import base from '../components/Builder/Library/Theme/Definitions/base';
import globals from '../components/PageBuilder/globals';

const legacyThemeFrom = definition => {
  const colors = { ...base.colors, ...definition.colors };
  const fonts = { ...base.fonts, ...definition.fonts };
  return _.merge({}, { colors: { ...colors, textGrey: colors.grey }, fonts }, base.legacy, definition.legacy);
};

export const themes = _.mapValues(definitions, legacyThemeFrom);

export const themeNamed = name => themes[name] || themes.oc;

const keys = _.reduce(themes, (result, theme) => _.union(result, Object.keys(theme)), []);
export default _.reduce(
  keys,
  (result, key) =>
    Object.defineProperty(result, key, {
      get: () => themeNamed(globals().PB_THEME)[key],
    }),
  {}
);

export const perTheme = factory => _.memoize(factory, () => globals().PB_THEME);
